import { IProgramId } from '@ucheba/store/institutions/programs/programId/types'
import { useMemo } from 'react'

interface IProps {
  subjects: IProgramId['requiredExams']
  additionalExams: IProgramId['additionalExams']
}

interface IUseAdmissionConditions {
  (props: IProps): {
    hrefToOlympiads: string | null
    hasAdditionalExamsDescriptions: boolean
  }
}

export const useAdmissionConditions: IUseAdmissionConditions = (props) => {
  const { subjects, additionalExams } = props

  const slug = useMemo(() => {
    if (subjects) {
      return subjects[0]?.exam.subject?.slug
    }

    return null
  }, [subjects])

  const hrefToOlympiads = useMemo(() => {
    if (slug) {
      return `/for-abiturients/olympiads/${slug}`
    }

    return null
  }, [slug])

  // у доп экзаменов есть ли описания
  const hasAdditionalExamsDescriptions = useMemo(() => {
    return additionalExams.some((item) => !!item.description)
  }, [additionalExams])

  return {
    hrefToOlympiads,
    hasAdditionalExamsDescriptions,
  }
}
